import React, { Fragment, useEffect, useState, useMemo } from "react";
import { Badge, Button, Input } from "reactstrap";
import Breadcrumb from "../../../../../layout/breadcrumb";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import {
    MaterialReactTable,
} from "material-react-table";
import { Box, Typography, TextField } from "@mui/material";
import debounce from "lodash/debounce";
import SweetAlert from "sweetalert2";
import { getFromLocalStorage } from "../../../../../hooks/useLocalStorage";
import {
    getAllPartnershipListBYRoleWithoutPagination,
    getBulkInvoiceDocumentByRole,
    downloadInvoiceZip,
    getBulkInvoiceDocumentByRoleNew,
    getDocumentsAndCalculationOfInvoice,
    invoiceReportDownload,
    getSmOldBpList,
} from "../../../../../api";
import GetButtons from "../../../../common/getButtons";
import formatedDate from "../../../../../utilities/formatedDate";
import convertToRupees from "../../../../../utilities/convertToRupees";
import ViewPolicyModal from "../../view-policy-details/view-policy-modal";
import { downloadDocumentReceipt } from "../../../../../api/dealership";
import BulkInvoiceDocumentsModal from "./BulkInvoiceDocumentsModal";
import { ExportToCsv } from "export-to-csv";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ClaimInvoice from "../../Claim-invoice";
import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';

const BulkCutnpay = () => {

    const [certificateData, setCertificateData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({});
    const [count, setCount] = useState(0);
    const [businessPartnerInfo, setBusinessPartnerInfo] = useState();
    const [partners, setPartners] = useState([]);
    const [oldPartners, setOldPartners] = useState([]);
    const [selectedBP, setSelectedBP] = useState();
    const [paymentStatus, setPaymentStatus] = useState(null);
    const location = useLocation();
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedClaimsCount, setSelectedClaimsCount] = useState(0);
    // const [startDate, setStartDate] = useState("");
    // const [endDate, setEndDate] = useState("");
    
    const ROLE = getFromLocalStorage("ROLE");
    // const roleId = ROLE?.role_id || getFromLocalStorage("user")?.user?.role_id;
    const roleKey = ROLE?.key || getFromLocalStorage("user")?.role?.key || "";
    const isFinanceOrHo = roleKey?.toUpperCase() === "FINANCE" || roleKey?.toUpperCase() === "HO";

    // Modals
    const [viewPolicyModal, setViewPolicyModal] = useState(false);
    const toggleViewPolicyModal = () => setViewPolicyModal(!viewPolicyModal);

    const [offlinePayment, setOfflinePayment] = useState(false);
    const toggleOffline = () => setOfflinePayment(!offlinePayment);

    const [documentsModal, setDocumentsModal] = useState(false);
    const toggleDocumentsModal = () => setDocumentsModal(!documentsModal);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [exportData, setExportData] = useState([]);
    const roleId = getFromLocalStorage("ROLE")?.role_id;
    const partnershipId = getFromLocalStorage("user")?.partnership_id;
    
    const handleGenerateReceipt = async (documentNo, rowData = null) => {
        try {
            let fileBlob = null;
            const user = getFromLocalStorage("user") || {};
            const partnershipId =
                rowData?.partnership_id ||
                (Array.isArray(selectedBP) && selectedBP.length > 0 && selectedBP[0] !== 'ALL' ? selectedBP[0] : null) ||
                businessPartnerInfo?.partnership_id ||
                businessPartnerInfo?.id ||
                user?.partnerInfo?.partnership_id ||
                user?.partnership_id ||
                null;
            const roleId = getFromLocalStorage("ROLE")?.role_id || user?.role_id;
            const invoiceNumber = rowData?.invoice_number || documentNo;

            let validDocCodes = [];

            // 1. Fetch documents under this invoice to get real document unique codes
            if (invoiceNumber || rowData?.group_id) {
                try {
                    const docRes = await getDocumentsAndCalculationOfInvoice(roleId, {
                        group_id: rowData?.group_id || null,
                        invoice_number: invoiceNumber,
                        partnership_id: partnershipId,
                    });

                    const docsList =
                        docRes?.data?.result?.documentTxnList ||
                        docRes?.data?.result?.documentDetails ||
                        (Array.isArray(docRes?.data?.result) ? docRes?.data?.result : []) ||
                        (Array.isArray(rowData?.documentDetails) ? rowData.documentDetails : []);

                    // Filter out CANCELLED documents to only get active documents
                    const activeDocs = docsList.filter((d) => {
                        const st = String(d?.status || d?.claim_status || '').toUpperCase();
                        return st !== 'CANCELLED' && st !== 'CANCELED';
                    });

                    const chosenDocs = activeDocs.length > 0 ? activeDocs : docsList;
                    validDocCodes = chosenDocs
                        .map((d) => d?.documentCode || d?.document_unique_code || d?.first_document_code)
                        .filter((code) => code && code !== documentNo && code !== invoiceNumber && !String(code).startsWith('INV'));
                } catch (fallbackErr) {
                    console.error("Error fetching invoice documents:", fallbackErr);
                }
            }

            // Check if rowData directly has document details or a real document code (not invoice number)
            if (validDocCodes.length === 0 && Array.isArray(rowData?.documentDetails) && rowData.documentDetails.length > 0) {
                const activeDocs = rowData.documentDetails.filter((d) => {
                    const st = String(d?.status || d?.claim_status || '').toUpperCase();
                    return st !== 'CANCELLED' && st !== 'CANCELED';
                });
                const chosenDocs = activeDocs.length > 0 ? activeDocs : rowData.documentDetails;
                validDocCodes = chosenDocs
                    .map((d) => d?.document_unique_code || d?.documentCode || d?.documentNo)
                    .filter((code) => code && code !== documentNo && code !== invoiceNumber && !String(code).startsWith('INV'));
            }

            if (validDocCodes.length === 0) {
                if (rowData?.first_document_code && rowData.first_document_code !== documentNo && rowData.first_document_code !== invoiceNumber && !String(rowData.first_document_code).startsWith('INV')) {
                    validDocCodes.push(rowData.first_document_code);
                }
                if (rowData?.document_unique_code && rowData.document_unique_code !== documentNo && rowData.document_unique_code !== invoiceNumber && !String(rowData.document_unique_code).startsWith('INV')) {
                    validDocCodes.push(rowData.document_unique_code);
                }
            }

            // Deduplicate codes
            validDocCodes = [...new Set(validDocCodes)];

            if (validDocCodes.length === 0) {
                toast.error("Could not find real document unique code for this invoice receipt.");
                return;
            }

            // 2. Call receipt API ONLY with real document unique codes (never invoice number)
            for (const code of validDocCodes) {
                try {
                    const res = await downloadDocumentReceipt(code);
                    if (res?.data?.code === 200 && res?.data?.result) {
                        fileBlob = res;
                        break;
                    }
                } catch (docErr) {
                    console.warn(`Receipt download attempt failed for document unique code ${code}:`, docErr?.response?.data || docErr);
                }
            }

            if (fileBlob?.data?.code === 200 && fileBlob?.data?.result) {
                const fileUrl = fileBlob.data.result;
                const newWindow = window.open(fileUrl, '_blank');
                if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                toast.success("Receipt downloaded successfully!");
            } else {
                const errMsg = fileBlob?.data?.error || fileBlob?.data?.message || "Failed to download receipt.";
                toast.error(errMsg);
            }
        } catch (error) {
            console.error("Failed to download receipt:", error);
            const errMsg = error?.response?.data?.error || error?.response?.data?.message || "Error generating receipt. Please try again.";
            toast.error(errMsg);
        }
    };

    const loadInvoiceDocumentsForModal = async (invoice) => {
        if (!invoice) return;

        try {
            const user = getFromLocalStorage("user") || {};
            const partnershipId =
                invoice.partnership_id ||
                (Array.isArray(selectedBP) && selectedBP.length > 0 && selectedBP[0] !== 'ALL' ? selectedBP[0] : null) ||
                businessPartnerInfo?.partnership_id ||
                businessPartnerInfo?.id ||
                user?.partnerInfo?.partnership_id ||
                user?.partnership_id ||
                null;
            const groupId = invoice.group_id || null;

            const payload = {
                group_id: groupId,
                invoice_number: invoice.invoice_number,
                partnership_id: partnershipId,
            };

            const roleId = getFromLocalStorage("ROLE")?.role_id || user?.role_id;
            const response = await getDocumentsAndCalculationOfInvoice(roleId, payload);

            const result = response?.data?.result || response?.data;

            if (response.status === 200) {
                setSelectedInvoice(result);
                setDocumentsModal(true);
            } else {
                toast.error(result?.error || "Failed to fetch invoice document details.");
            }

        } catch (error) {
            console.log("❌ Error fetching document details:", error);
            toast.error(error?.response?.data?.error || "Failed to fetch invoice document details.");
        }
    };
    
    const downloadInvoiceReport = async (documentType) => {
        console.log('downloadInvoiceReport called')
        try {
            setIsLoading(true);


            // Validate dates are selected
            if (!startDate || !endDate) {
                toast.error("Please select the start and end date.");
                return;
            }

            const start = new Date(startDate);
            const end = new Date(endDate);
            // Validate start date is not after end date
            if (start > end) {
                toast.error("Start date cannot be greater than end date.");
                return;
            }

            // Validate date range is within 1 year
            const oneYearLater = new Date(start);
            oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

            if (end > oneYearLater) {
                toast.error("Date range cannot be more than 1 year.");
                return;
            }

            let partnershipId;
            console.log('downloadInvoiceReport', roleKey);
            if ((roleKey == "SALES_MANAGER" || roleKey == "HO" || roleKey == "FINANCE" || roleKey == "TEAM_MEMBER") && selectedBP?.length > 0) {
                // columnFilters.push({ id: "partnership_id", value: selectedBP?.length > 0 ? selectedBP[0] : null });
                partnershipId = selectedBP?.length > 0 ? selectedBP : null;
            }

            if (roleKey === "DEALERSHIP_MANAGER") {
                partnershipId = getFromLocalStorage("user")?.partnership_id;
            }

            console.log('downloadInvoiceReport payload:', startDate, endDate, documentType, partnershipId, roleId)
            const response = await invoiceReportDownload(startDate, endDate, documentType, partnershipId, roleId, true);

            console.log(response, "downloadInvoiceReport response");

            const fileUrl = response?.data?.result;
            console.log('downloadInvoiceReport fileUrl', fileUrl);

            if (fileUrl) {
              window.open(fileUrl, "_blank");
              toast.success(
                `${documentType} report generated successfully`
              );
            } else if (response?.data?.code === 200 || response?.data?.msg) {
              toast.success(
                response?.data?.msg || "The generated report will be sent to your registered E-mail Id shortly."
              );
            } else {
              toast.error(
                response?.data?.error || response?.data?.msg || "Failed to generate report"
              );
            }

        } catch (error) {
            console.log(error, "error");
            console.error(
              `${documentType} report generation failed`,
              error
            );

            const errorMsg =
              error?.response?.data?.error ||
              error?.response?.data?.msg ||
              error?.message ||
              (typeof error === "string" ? error : `${documentType} report generation failed`);

            toast.error(errorMsg);
        } finally {
            setIsLoading(false);
        }
    };

    const downloadInvoiceExport = async (documentType) => {
        console.log('downloadInvoiceReport called')
        try {
            setIsLoading(true);

            // Validate dates are selected
            if (!startDate || !endDate) {
                toast.error("Please select the start and end date.");
                return;
            }

            const start = new Date(startDate);
            const end = new Date(endDate);
            // Validate start date is not after end date
            if (start > end) {
                toast.error("Start date cannot be greater than end date.");
                return;
            }

            // Validate date range is within 1 year
            const oneYearLater = new Date(start);
            oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

            if (end > oneYearLater) {
                toast.error("Date range cannot be more than 1 year.");
                return;
            }

            let filterParams = [...columnFilters];
            let partnershipId;
            console.log('downloadInvoiceReport', roleKey);
            const needsBPDropdown = ["SALES_MANAGER", "HO", "FINANCE", "TEAM_MEMBER"].includes(roleKey);
            if (needsBPDropdown) {
                if (selectedBP?.length > 0) {
                    filterParams.push({ id: "partnership_id", value: selectedBP });
                } else {
                    toast.error("Please select a Business Partner to export.");
                    setIsLoading(false);
                    return;
                }
            }

            const response = await getBulkInvoiceDocumentByRoleNew(roleId, 0, 5000, globalFilter, filterParams, sorting, startDate, endDate, true, "CUTNPAY");

            const rawList = Array.isArray(response?.data?.result)
                ? response?.data?.result
                : response?.data?.result?.documentDetails || [];

            if (rawList.length === 0) {
                toast.error("No data found for the selected filters.");
                setIsLoading(false);
                return;
            }

            const options = {
                fieldSeparator: ",",
                quoteStrings: '"',
                decimalSeparator: ".",
                showLabels: true,
                showTitle: false,
                filename: `Bulk_CutNPay_Invoices_${new Date().getTime()}`,
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: false,
                headers: [
                    "Business Partner",
                    "Invoice Number",
                    "Total Document",
                    "Base Premium",
                    "GST Amount",
                    "Total Premium",
                    "Total Commission",
                    "Net Payable",
                    "Month",
                    "Proposer Name",
                    "Status",
                ],
            };

            const csvExporter = new ExportToCsv(options);
            const csvData = rawList.map((item) => ({
                "Business Partner": businessPartnerInfo?.name || "",
                "Invoice Number": item?.invoice_number || "",
                "Total Document": item?.total_documents || 0,
                "Base Premium": (item?.total_premium || 0) - (item?.gst_amount || 0),
                "GST Amount": item?.gst_amount || 0,
                "Total Premium": item?.total_premium || 0,
                "Total Commission": item?.total_commission || 0,
                "Net Payable": item?.net_payable || 0,
                "Month": formatedDate(item?.createdAt) || "",
                "Proposer Name": item?.proposer ? `${item.proposer.proposer_first_name || ""} ${item.proposer.proposer_last_name || ""}`.trim() : "",
                "Status": item?.payment_status || "PENDING",
            }));

            csvExporter.generateCsv(csvData);

            toast.success(`Excel report generated successfully`);
            setIsLoading(false);

        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.error || "Error in downloading report");
            setIsLoading(false);
        }
    }

    const RenderFilters = () => (
        <>
            <TextField
                label="Start Date"
                type="date"
                size="small"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 160 }}
            />

            <TextField
                label="End Date"
                type="date"
                size="small"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 160 }}
            />

            <Button
                color="secondary"
                size="sm"
                className="btnCustom"
                variant="outlined"
                onClick={() => {
                    setStartDate("");
                    setEndDate("");
                }}
            >
                <i
                    className="fa fa-times"
                // style={{ marginRight: "5px" }}
                ></i>
                {/* Clear */}
            </Button>

            {(roleKey == "DEALERSHIP_MANAGER" || roleKey === "SALES_MANAGER" || roleKey === "TEAM_MEMBER" || roleKey === "HO" || roleKey === "FINANCE") && (

                <>
                    <Button
                        color="success"
                        size="sm"
                        className="btnCustom"
                        variant="contained"
                        onClick={() => downloadInvoiceReport("EXCEL")}
                    >
                        <i
                            className="fa fa-file-excel-o"
                            style={{ marginRight: "5px" }}
                        ></i>
                        Excel
                    </Button>

                    {/* PDF */}
                    {(roleKey == "DEALERSHIP_MANAGER" || roleKey === "SALES_MANAGER" || roleKey === "TEAM_MEMBER" || roleKey === "HO") && (
                        <Button
                            color="primary"
                            size="sm"
                            className="btnCustom"
                            variant="contained"
                            onClick={() => downloadInvoiceReport("PDF")}
                        >
                            <i
                                className="fa fa-file-pdf-o"
                                style={{ marginRight: "5px" }}
                            ></i>
                            PDF
                        </Button>
                    )}
                </>
            )}
        </>
    );

    const [invoiceDetailModal, setInvoiceDetailModal] = useState(false);
    const toggleInvoiceDetailModal = () => {
        // Only validate when trying to open the modal
        if (!invoiceDetailModal) {
            if (Object.keys(rowSelection).length === 0) {
                toast.error("Please select at least one invoice to proceed!");
                return;
            }

            // Check if any selected invoices are not PENDING
            const selectedInvoiceNumbers = Object.keys(rowSelection);
            const hasInvalidInvoices = selectedInvoiceNumbers.some(invoiceNumber => {
                const invoice = certificateData.find(item => item.invoice_number === invoiceNumber);
                const status = (invoice?.payment_status || "PENDING").toUpperCase();
                return status !== "PENDING";
            });

            // if (hasInvalidInvoices) {
            //     toast.error("Only invoices with PENDING status can be selected for payment.");
            //     return;
            // }

            if (Object.keys(rowSelection).length > 100) {
                toast.error("You can't select more than 100 rows for payment!");
                return;
            }
        }

        // Keep track of how many documents are being processed
        setSelectedClaimsCount(Object.keys(rowSelection).length);

        // Reset selection / offline state when closing the modal
        if (invoiceDetailModal) {
            setRowSelection({});
            setOfflinePayment(false);
        }

        setInvoiceDetailModal(!invoiceDetailModal);
    };

    const onDownload = async () => {
        if (Object.keys(rowSelection).length === 0) {
            toast.error("Please select at least one row to download!");
            return;
        }

        const selectedInvoiceNumbers = Object.keys(rowSelection);

        try {
            const payload = {
                invoice_numbers: selectedInvoiceNumbers,
            };

            const response = await downloadInvoiceZip(payload);

            if (response?.status === 200 && response?.data?.result) {
                const fileUrl = response.data.result;

                const link = document.createElement('a');
                link.href = fileUrl;
                link.download = `invoices_${new Date().getTime()}.zip`;
                link.target = '_blank';

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                toast.success("Invoice download started successfully!");
            } else {
                toast.error("Failed to download invoices - No file URL received");
            }
            setRowSelection({});
        } catch (error) {
            console.error("❌ Download error:", error);
            toast.error(error?.response?.data?.error || "Failed to download invoices");
        }
    };

    const defaultFilter = [
        { id: "payment_by_key", value: 1 },
        { id: "is_bulk", value: true }, // Filter for bulk documents only
    ];

    const [columnFilters, setColumnFilters] = useState(defaultFilter);
    const debouncedSetColumnFilters = debounce(setColumnFilters, 500);
    const [rowSelection, setRowSelection] = useState({});
    const [globalFilter, setGlobalFilter] = useState("");
    const [sorting, setSorting] = useState([{ id: "model_id", desc: true }]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });


    const canSelectRows =
        roleKey !== "HO" &&
        roleKey !== "FINANCE" &&
        roleKey !== "TEAM_MEMBER";

    const calculatePayableAmount = (documentData, partnerCommission) => {
        const GST_RATE = 18;
        const TDS_RATE = 2;

        const totalPremium = documentData.base_premium + (documentData.addons_premium || 0);
        const commissionAmt = documentData.commission_amount || totalPremium * (partnerCommission?.commission_percent / 100);
        const baseAmt = partnerCommission?.wallet_type === "CUTNPAY" ? totalPremium - commissionAmt : totalPremium;

        const new_base_amt = documentData.discounted_base_premium ? documentData.discounted_base_premium : baseAmt;
        const new_total_Premium = documentData?.discounts[0]?.discount_percent > 0
            ? documentData.discounted_base_premium + (documentData.addons_premium || 0)
            : totalPremium;

        const gst = (new_total_Premium * GST_RATE) / 100;
        const tds = (commissionAmt * TDS_RATE) / 100;

        const base_paybale_ammount = partnerCommission?.wallet_type === "CUTNPAY"
            ? new_total_Premium - commissionAmt
            : new_total_Premium;

        const plan = Array.isArray(documentData.plan) ? documentData.plan[0] : documentData.plan;

        return {
            plan: plan,
            documentCode: documentData.document_unique_code,
            document_id: documentData.document_id,
            memberPremium: totalPremium,
            commissionAmount: commissionAmt,
            baseAmount: baseAmt,
            gstAmount: gst,
            tdsAmount: tds,
            netPayableAmt: base_paybale_ammount + gst,
        };
    };

    const fetchTravelPartnerships = async () => {
        try {
            const response = await getAllPartnershipListBYRoleWithoutPagination("CUTNPAY");
            if (response.status === 200) {
                const res = response?.data?.result?.partnershipData;
                const partnershipOptions = [];

                res.map((item) => {
                    const pcode = item?.partnership_code?.length > 15
                        ? item?.partnership_code?.slice(0, 15) + "..."
                        : item?.partnership_code;

                    const obj = {
                        value: item.partnership_id,
                        label: `${item.name} (${pcode})`,
                        user_name: item?.user?.name || "",
                        is_active: item.is_active,
                        is_kyc_active: item.is_kyc_active,
                        wallet_closure_status: item.wallet_closure_status,
                        wallet_balance: item.user?.user_wallet?.amount || 0,
                        msc_percentage: item.commission_percent || 0,
                        partner_info: item,
                    };

                    if (obj.is_active && obj.is_kyc_active && obj.wallet_balance > 0) {
                        partnershipOptions.push(obj);
                    }
                });

                setPartners(partnershipOptions);
            }
        } catch (error) {
            console.error("Error fetching business partnerships", error);
            toast.error("Failed to load business partnerships.");
        }
    };

    const fetchOldTravelPartnerships = async () => {
        try {
            const user = getFromLocalStorage('user');
            if (roleKey === "SALES_MANAGER" && user?.user_id) {
                const response = await getSmOldBpList(user.user_id);
                if (response.status === 200) {
                    const res = response?.data?.result?.bpList || [];
                    const partnershipOptions = res.map((item) => ({
                        value: item.partnership_id,
                        label: item.name,
                    }));
                    setOldPartners(partnershipOptions);
                }
            }
        } catch (error) {
            console.error("Error fetching old business partnerships", error);
        }
    };


    useEffect(() => {
        if (selectedBP?.length > 0) {
            const bpInfo = partners?.find(bp => bp.value == selectedBP[0]);
            setBusinessPartnerInfo(bpInfo?.partner_info || {});
        } else {
            setBusinessPartnerInfo(getFromLocalStorage('user').partnerInfo || {});
        }
    }, [selectedBP, partners]);

    const fetchInvoices = async (page, rowsPerPage, searchText, columnFilters, sorting, startDate, endDate) => {
        const roleId = getFromLocalStorage("ROLE")?.role_id;
        const res = await getBulkInvoiceDocumentByRoleNew(roleId, page, rowsPerPage, searchText, columnFilters, sorting, startDate, endDate, false, "CUTNPAY");

        const rawList = Array.isArray(res?.data?.result)
            ? res?.data?.result
            : res?.data?.result?.documentDetails || [];

        setCertificateData(rawList);
        const totalCount = res?.data?.result?.totalCount !== undefined
            ? res?.data?.result?.totalCount
            : rawList.length;
        setCount(totalCount);
        setIsLoading(false);
        return res;
    };

    const fetchAllPolicyDocuments = async (page, rowsPerPage, searchText, columnFilters, sorting, startDate, endDate) => {
        setIsLoading(true);
        try {
            const needsBPDropdown = ["SALES_MANAGER", "HO", "FINANCE", "TEAM_MEMBER"].includes(roleKey);
            
            if (needsBPDropdown) {
                let filters = [...columnFilters];
                if (selectedBP?.length > 0) {
                    filters.push({ id: "partnership_id", value: selectedBP });
                    await fetchInvoices(page, rowsPerPage, searchText, filters, sorting, startDate, endDate);
                } else {
                    setCertificateData([]);
                    setCount(0);
                    setIsLoading(false);
                }
            } else {
                await fetchInvoices(page, rowsPerPage, searchText, columnFilters, sorting, startDate, endDate);
            }
        } catch (err) {
            toast.error(err.response?.data?.error || "Failed to fetch documents");
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchTravelPartnerships();
        fetchOldTravelPartnerships();
    }, []);

    const [refreshTrigger, setRefreshTrigger] = useState(0);

    useEffect(() => {
        const handleRefresh = () => setRefreshTrigger((prev) => prev + 1);
        window.addEventListener('refresh-invoices', handleRefresh);
        return () => window.removeEventListener('refresh-invoices', handleRefresh);
    }, []);

    useEffect(() => {
        fetchAllPolicyDocuments(
            pagination.pageIndex,
            pagination.pageSize,
            globalFilter,
            columnFilters,
            sorting,
            startDate,
            endDate
        );
    }, [pagination.pageIndex, pagination.pageSize, globalFilter, columnFilters, sorting, selectedBP, refreshTrigger, startDate, endDate]);

    const refresh = () => {
        fetchAllPolicyDocuments(
            pagination.pageIndex,
            pagination.pageSize,
            "",
            defaultFilter,
            [{ id: "model_id", desc: true }],
            startDate,
            endDate
        );
    };

    const viewPolicy = (e, data, type) => {
        setData(data);
        if (type === "policy") {
            setViewPolicyModal(!viewPolicyModal);
        }
    };

    useEffect(() => {
        setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    }, [globalFilter, columnFilters]);

    // Payment Status from URL
    useEffect(() => {

        const queryParams = new URLSearchParams(location.search);
        const status = queryParams.get("status");
        const txnId = queryParams.get("txnid");
        const amount = queryParams.get("amount");
        const bankRef = queryParams.get("bank_ref");

        if (status) {
            setPaymentStatus({ status, txnId, amount, bankRef });

            if (status === "success") {
                SweetAlert.fire({
                    title: "Payment Successful! 🎉",
                    icon: "success",
                    html: `
            <div style="text-align: left; background: #f8f9fa; padding: 15px; border-radius: 8px; border-left: 4px solid #10b981; font-family: 'Inter', sans-serif;">
              <p style="margin: 0 0 10px; font-size: 16px; color: #333;">
                <span style="display: inline-block; width: 120px; color: #6b7280; font-weight: 500;">Amount:</span> 
                <strong style="color: #111827;">INR ${amount}</strong>
              </p>
              <p style="margin: 0; font-size: 16px; color: #333;">
                <span style="display: inline-block; width: 120px; color: #6b7280; font-weight: 500;">Transaction ID:</span> 
                <strong style="color: #111827;">${txnId}</strong>
              </p>
            </div>
          `,
                    showCancelButton: true,
                    confirmButtonText: "Ok",
                });
            }

            window.history.replaceState({}, document.title, location.pathname);
        }
    }, [location]);

    useEffect(() => {
        if (!invoiceDetailModal) {
            setRowSelection({});
        }
    }, [invoiceDetailModal]);

    const columns = useMemo(
        () => [
            {
                accessorKey: "invoice_number",
                header: "Invoice No",
                enableSorting: false,
                Cell: ({ row }) => (
                    <div className="font-primary">{row.original.invoice_number || "N/A"}</div>
                ),
            },
            {
                accessorKey: "proposer_name",
                header: "Proposer Name",
                enableSorting: false,
                Cell: ({ row }) => {
                    const proposer = row.original?.proposer;
                    const firstName = proposer?.proposer_first_name || "";
                    const middleName = proposer?.proposer_middle_name || "";
                    const lastName = proposer?.proposer_last_name || "";
                    return (
                        <>
                            {proposer ? `${firstName} ${middleName} ${lastName}` : "N/A"}
                        </>
                    )
                },
            },
            {
                accessorKey: "total_documents",
                header: "Total Documents",
                enableSorting: false,
                Cell: ({ row }) => (
                    <Badge color="info">{row.original.total_documents || 0}</Badge>
                ),
            },
            {
                accessorKey: "total_premium_amount",
                header: "Total Base Amount",
                enableSorting: false,
                Cell: ({ row }) => (
                    <span className="font-weight-bold">
                        {convertToRupees(row.original.total_premium || 0, true)}
                    </span>
                ),
            },
            {
                accessorKey: "total_commission_amount",
                header: "Total Commission",
                enableSorting: false,
                Cell: ({ row }) => (
                    <span>
                        {convertToRupees(row.original.total_commission || 0, true)}
                    </span>
                ),
            },
            {
                accessorKey: "gst_amount",
                header: "GST Amount",
                enableSorting: false,
                Cell: ({ row }) => (
                    <span>
                        {convertToRupees(row.original.gst_amount || 0, true)}
                    </span>
                ),
            },
            {
                accessorKey: "net_payable_amount",
                header: "Net Payable",
                enableSorting: false,
                Cell: ({ row }) => (
                    <span className="text-success font-weight-bold">
                        {convertToRupees(row.original.net_payable || 0, true)}
                    </span>
                ),
            },
            {
                accessorKey: "wallet_type",
                header: "Wallet Type",
                enableSorting: false,
                filterVariant: 'select',
                filterSelectOptions: [
                    { text: 'Normal', value: 'NORMAL' },
                    { text: 'Cutnpay', value: 'CUTNPAY' }
                ],
                Cell: ({ row }) => (
                    <Badge color="primary">{row.original.wallet_type || "N/A"}</Badge>
                ),
            },
            {
                accessorKey: "utr",
                header: "UTR",
                enableSorting: false,
                Cell: ({ row }) => {
                    // Check if any document in the invoice has UTR
                    const docs = row.original.documentTxnList || [];
                    const utr = row.original.utr_number || docs[0]?.bcPaymentResponse?.bc_res?.Payu_UTR;
                    return <div>{utr || "N/A"}</div>;
                },
            },
            {
                accessorKey: "payment_date",
                header: "Payment Date",
                enableSorting: false,
                Cell: ({ row }) => {
                    // const docs = row.original.documentTxnList || [];
                    // const paymentDate = docs[0]?.bcPaymentResponse?.payment_date;
                    return (
                        <span>
                            {row.original?.payment_date ? formatedDate(row.original?.payment_date) : "-"}
                        </span>
                    );
                },
            },
            {
                accessorKey: "claim_status",
                header: "Status",
                enableSorting: false,
                filterVariant: 'select',
                filterSelectOptions: [
                    { text: 'Paid', value: 'PAID' },
                    { text: 'Pending', value: 'PENDING' },
                    { text: 'Failed', value: 'FAILED' }
                ],
                Cell: ({ row }) => {
                    // Get status from first document (all should have same status in an invoice group)
                    // const docs = row.original.documentTxnList || [];
                    const status = row.original.payment_status || "PENDING";
                    return (
                        <Badge
                            color={
                                status.toUpperCase() === "PAID" ? "success" :
                                    status.toUpperCase() === "PROCESSING" ? "light" :
                                        status.toUpperCase() === "PENDING" ? "warning" :
                                            status.toUpperCase() === "FAILED" ? "danger" :
                                                status.toUpperCase() === "PENDING_OFFLINE_APPROVAL" ? "warning" :
                                                    status.toUpperCase() === "PENDING_FROM_FINANCE" ? "warning" :
                                                        "default"
                            }
                        >
                            {status.toUpperCase() === "PENDING_OFFLINE_APPROVAL"
                                ? "Pending Offline Approval"
                                : status}
                        </Badge>
                    );
                },
            },
            {
                accessorKey: "actions",
                header: "Actions",
                enableSorting: false,
                Cell: ({ row }) => {
                    const paymentStatus = (row.original.payment_status || "").toUpperCase();
                    const isReceiptVisible = ["PAID", "PENDING_FOR_COMMISSION"].includes(paymentStatus) || !!row.original.is_receipt_generated;
                    const isReceiptGenerated = row.original.is_receipt_generated !== undefined ? row.original.is_receipt_generated : ["PAID", "PENDING_FOR_COMMISSION"].includes(paymentStatus);

                    return (
                        <div className="d-flex align-items-center">
                            <Button
                                color="primary"
                                size="sm"
                                className="mr-2"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    loadInvoiceDocumentsForModal(row.original);
                                    toggleDocumentsModal();
                                }}
                            >
                                <i className="fa fa-eye"></i> View
                            </Button>
                            {isReceiptVisible && (
                                <Button
                                    color="info"
                                    size="sm"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleGenerateReceipt(row.original.invoice_number, row.original);
                                    }}
                                    disabled={!isReceiptGenerated}
                                    title={!isReceiptGenerated ? "Receipt is generating..." : "Download Receipt"}
                                >
                                    <i className="fa fa-download"></i> Receipt
                                </Button>
                            )}
                        </div>
                    );
                },
            },
        ],
        [businessPartnerInfo],
    );

    return (
        <Fragment>
            <div>
                <Breadcrumb parent="Sales" title="Bulk Invoice" />

                {(roleKey === "SALES_MANAGER" || roleKey === "HO" || roleKey === "FINANCE" || roleKey === "TEAM_MEMBER") && (
                    <div style={{ maxWidth: 320, margin: '10px 0 20px 0' }}>
                        <Typeahead
                            id="bp-filter"
                            multiple={isFinanceOrHo}
                            clearButton
                            filterBy={(option, state) => {
                                if (isFinanceOrHo) {
                                    const query = (state.text || '').toLowerCase().trim();
                                    return !query || option.label?.toLowerCase().includes(query);
                                }
                                if (state.selected?.length > 0 && state.text?.trim() === state.selected[0]?.label?.trim()) {
                                    return true;
                                }
                                const query = (state.text || '').toLowerCase().trim();
                                return !query || option.label?.toLowerCase().includes(query);
                            }}
                            options={[
                                ...(isFinanceOrHo ? [{ value: 'ALL', label: 'Select All', group: 'Actions' }] : []),
                                ...(partners || []).map(p => ({ ...p, group: 'Active BP' })),
                                ...(roleKey === "SALES_MANAGER" ? (oldPartners || []).map(p => ({ ...p, group: 'Old BP' })) : [])
                            ]}
                            labelKey="label"
                            placeholder="Select Partner"
                            renderMenu={(results, menuProps) => {
                                let items = [];
                                let currentGroup = null;

                                results.forEach((option, index) => {
                                    if (option.group !== currentGroup) {
                                        currentGroup = option.group;
                                        items.push(
                                            <Menu.Divider key={`${currentGroup}-divider`} />
                                        );
                                        items.push(
                                            <Menu.Header key={`${currentGroup}-header`}>
                                                {currentGroup}
                                            </Menu.Header>
                                        );
                                    }
                                    items.push(
                                        <MenuItem key={index} option={option} position={index}>
                                            {option.label}
                                        </MenuItem>
                                    );
                                });

                                return <Menu {...menuProps}>{items}</Menu>;
                            }}
                            onChange={(selected) => {
                                if (isFinanceOrHo) {
                                    const isSelectAll = selected.some(s => s.value === 'ALL');
                                    if (isSelectAll) {
                                        const allValues = [...(partners || []), ...(roleKey === "SALES_MANAGER" ? (oldPartners || []) : [])].map(p => p.value);
                                        setSelectedBP(allValues);
                                    } else {
                                        setSelectedBP(selected.map(s => s.value));
                                    }
                                } else {
                                    setSelectedBP(selected?.length > 0 ? [selected[0].value] : []);
                                }
                                setPagination((prev) => ({ ...prev, pageIndex: 0 }));
                            }}
                            selected={
                                (() => {
                                    const combined = [...(partners || []), ...(roleKey === "SALES_MANAGER" ? (oldPartners || []) : [])];
                                    if (isFinanceOrHo && selectedBP?.length === combined.length && combined.length > 0) {
                                        return [{ value: 'ALL', label: `All Partners Selected (${combined.length})`, group: 'Actions' }];
                                    }
                                    return combined.filter(p => selectedBP?.includes(p.value));
                                })()
                            }
                        />
                    </div>
                )}
                <MaterialReactTable
                    columns={columns || []}
                    data={certificateData || []}
                    enableGlobalFilter={false}
                    initialState={{ showColumnFilters: false, density: "compact" }}
                    positionToolbarAlertBanner="none"
                    enableMultiRowSelection={canSelectRows}
                    enableRowSelection={
                        canSelectRows
                            ? (row) => {
                                const docs = row.original.documentTxnList || [];
                                const status =
                                    row.original?.payment_status ||
                                    docs[0]?.claim_status ||
                                    "PENDING";

                                return status?.toUpperCase() === "PENDING" || status?.toUpperCase() === "FAILED";
                            }
                            : false
                    }
                    getRowId={(row) => row.invoice_number}
                    onRowSelectionChange={setRowSelection}
                    muiTableBodyRowProps={({ row }) => ({
                        ...(canSelectRows && {
                            onClick: row.getToggleSelectedHandler(),
                        }), sx: { cursor: "pointer" },
                    })}
                    {
                    ...{
                        renderTopToolbarCustomActions: () => (
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: "0.3rem",
                                    p: "0.5rem",
                                    flexWrap: "wrap",
                                }}
                            >
                                {/* {roleKey === "FINANCE" && RenderFilters()} */}
                                <GetButtons onClick={refresh} type="refresh" />

                                {roleKey !== "HO" && roleKey !== "FINANCE" && roleKey !== "TEAM_MEMBER" && (
                                    <>
                                        <Button
                                            color="primary"
                                            size="sm"
                                            className="btnCustom"
                                            onClick={toggleInvoiceDetailModal}
                                            disabled={Object.keys(rowSelection).length === 0}
                                        >
                                            <i className="fa fa-plus"></i> Pay
                                        </Button>

                                        <Button
                                            color="primary"
                                            size="sm"
                                            className="btnCustom"
                                            onClick={() => {
                                                toggleInvoiceDetailModal();
                                                toggleOffline();
                                            }}
                                            disabled={Object.keys(rowSelection).length === 0}
                                        >
                                            Offline
                                        </Button>

                                        <Button
                                            color="primary"
                                            size="sm"
                                            className="btnCustom"
                                            onClick={onDownload}
                                            disabled={Object.keys(rowSelection).length === 0}
                                        >
                                            <i className="fa fa-download"></i> Download
                                        </Button>

                                        <Badge color="success">
                                            <Typography
                                                variant="body1"
                                                sx={{ fontSize: "12px" }}
                                            >
                                                Selected: {Object.keys(rowSelection).length}
                                            </Typography>
                                        </Badge>

                                    </>
                                )}
                                <RenderFilters />
                            </Box>
                        ),
                    }
                    }
                    columnResizeMode="onChange"
                    manualFiltering
                    manualPagination
                    manualSorting
                    onColumnFiltersChange={debouncedSetColumnFilters}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={count}
                    state={{
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        sorting,
                        showLoadingOverlay: false,
                        showProgressBars: isLoading,
                        rowSelection,
                    }}
                    enableFacetedValues
                />
            </div>

            {viewPolicyModal && (
                <ViewPolicyModal
                    isOpen={viewPolicyModal}
                    toggle={toggleViewPolicyModal}
                    selectedPolicyData={data}
                />
            )}

            {invoiceDetailModal && (
                <ClaimInvoice
                    isOpen={invoiceDetailModal}
                    toggle={toggleInvoiceDetailModal}
                    selectedPolicyData={data}
                    claimsCount={selectedClaimsCount}
                    selectedDocumentIds={rowSelection} // Pass selected IDs
                    offlinePayment={offlinePayment}
                    setOfflinePayment={setOfflinePayment}
                    partnerInfo={businessPartnerInfo}
                    isBulk={true}
                    groupId={certificateData.filter((item) => rowSelection[item.invoice_number]).map((item) => item.group_id)}
                />
            )}

            {documentsModal && (
                <BulkInvoiceDocumentsModal
                    isOpen={documentsModal}
                    toggle={toggleDocumentsModal}
                    invoiceData={selectedInvoice}
                    invoiceStatus={certificateData?.find(inv => inv.invoice_number === selectedInvoice?.invoice_number)?.payment_status || "N/A"}
                />
            )}
        </Fragment>
    );
};


const BulkInvoiceCutnpayWithLocalizationProvider = () => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <BulkCutnpay />
    </LocalizationProvider>
);

export default BulkInvoiceCutnpayWithLocalizationProvider;
